/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Timeout
 */
export interface Timeout {
  /**
   * Only valid for when the simulation is paused. Reset the simulation timeout to the given value. Defaults to 300 seconds
   */
  timeout: number;
}

/**
 * Check if a given object implements the Timeout interface.
 */
export function instanceOfTimeout(value: object): value is Timeout {
  if (!("timeout" in value) || value["timeout"] === undefined) return false;
  return true;
}

export function TimeoutFromJSON(json: any): Timeout {
  return TimeoutFromJSONTyped(json, false);
}

export function TimeoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): Timeout {
  if (json == null) {
    return json;
  }
  return {
    timeout: json["timeout"],
  };
}

export function TimeoutToJSON(json: any): Timeout {
  return TimeoutToJSONTyped(json, false);
}

export function TimeoutToJSONTyped(
  value?: Timeout | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    timeout: value["timeout"],
  };
}
